<template>
  <b-card no-body>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="upload" />อัปโหลดเอกสารจากระบบ KMITL e-Office
    </h6>

    <table class="table mb-0">
      <tbody>
        <tr>
          <td class="align-middle">
            <strong>สถานะ</strong>
          </td>
          <td class="align-middle">
            <span v-if="!status" class="text-danger"><font-awesome-icon icon="exclamation-triangle" />ยังไม่ได้อัปโหลดเอกสารจาก e-Office</span>
            <span v-else class="text-success"><font-awesome-icon icon="download" />อัปโหลดเอกสารแล้ว (<a :href="fileUrl">ดาวน์โหลด</a>)</span>
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>อัปโหลดไฟล์เอกสาร</strong>
          </td>
          <td class="align-middle">
            <b-form-file
              v-model="file"
              placeholder="เลือกไฟล์..."
              drop-placeholder="ลากและวางไฟล์ที่นี่"
              type="pdf"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div class="m-2 text-center">
      <b-button variant="primary" @click="$emit('upload')">อัพโหลดเอกสาร</b-button>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: null },
    status: { type: String, default: null }
  },
  data () {
    return {
      file: null
    }
  },
  computed: {
    fileUrl () {
      return process.env.VUE_APP_FILE_BASE_URL + '/' + this.status
    }
  },
  watch: {
    file (newFile) {
      this.$emit('input', newFile)
    }
  }
}
</script>

<style scoped lang="scss">
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 220px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
